import * as RefApi from 'saas/references/api';
import * as RefConstants from 'saas/references/constants';
import { createAction } from 'redux-actions';
import { fetchJson } from '../../../../../../utils/fetch';

export const fetchRequirementsAction = createAction('case.FETCH_REQUIREMENTS');
export const fetchRequirementsSuccessAction = createAction(
  'case.FETCH_REQUIREMENTS_SUCCESS'
);

const getAnnexTasks = () => {
  return fetchJson(
    '/pco-manager/settings/annex-activities.json?starting_after=0&limit=10'
  ).then(res => {
    const annex1 = res.entities.find(e => e.type === 'ANNEX_1');
    const annex2 = res.entities.find(e => e.type === 'ANNEX_2');

    return Promise.all([
      fetchJson(`/pco-manager/settings/annex-activities.json/${annex1.id}`),
      fetchJson(`/pco-manager/settings/annex-activities.json/${annex2.id}`),
    ]);
  });
};

export const fetchRequirements = siteCase => (dispatch, getState) => {
  if (getState().requirements.isFetching) {
    return Promise.resolve();
  }

  dispatch(fetchRequirementsAction());

  const doFetch = () =>
    Promise.all([
      RefApi.getReferencesByType(RefConstants.INFESTATION_LEVEL, siteCase),
      RefApi.getReferencesByType(RefConstants.INFRA_TYPE, siteCase),
      RefApi.getReferencesByType(RefConstants.TIME_UNIT, siteCase),
      RefApi.getReferencesByType(RefConstants.CONTRACT_TYPE, siteCase),
      RefApi.getReferencesByType(RefConstants.TARGET_RAT, siteCase),
      RefApi.getReferencesByType(RefConstants.TARGET_INSECT, siteCase),
      RefApi.getReferencesByType(RefConstants.TREATMENT_INSECT, siteCase),
      RefApi.getReferencesByType(RefConstants.TARGET_OTHER, siteCase),
      RefApi.getReferencesByType(RefConstants.TREATMENT_OTHER, siteCase),
      getAnnexTasks(),
      RefApi.getReferencesByType(
        RefConstants.TASK_ONE_SIMPLE_LIST_ONE,
        siteCase
      ),
      RefApi.getReferencesByType(
        RefConstants.TASK_ONE_SIMPLE_LIST_TWO,
        siteCase
      ),
      RefApi.getReferencesByType(RefConstants.TASK_ONE_COMPLEX_LIST, siteCase),
      RefApi.getReferencesByType(
        RefConstants.TASK_TWO_SIMPLE_LIST_ONE,
        siteCase
      ),
      RefApi.getReferencesByType(
        RefConstants.TASK_TWO_SIMPLE_LIST_TWO,
        siteCase
      ),
      RefApi.getReferencesByType(RefConstants.TASK_TWO_COMPLEX_LIST, siteCase),
      RefApi.getReferencesByType(RefConstants.PLACE, siteCase),
      RefApi.getReferencesByType(RefConstants.PLACE_ACCESSIBILITY, siteCase),
    ]);

  // Fetching requirements and planning
  const promise = doFetch().then(response =>
    dispatch(
      fetchRequirementsSuccessAction({
        infestationLevels: response[0],
        infraTypes: response[1],
        timeUnits: response[2],
        contractTypes: response[3],
        ratSpecies: response[4],
        insectSpecies: response[5],
        insectTreatments: response[6],
        otherSpecies: response[7],
        otherTreatments: response[8],
        annexConf: {
          ANNEX_1: response[9][0],
          ANNEX_2: response[9][1],
        },
        annex1SimpleList1: response[10],
        annex1SimpleList2: response[11],
        annex1ComplexList: response[12],
        annex2SimpleList1: response[13],
        annex2SimpleList2: response[14],
        annex2ComplexList: response[15],
        placesRef: response[16],
        accessibilityRef: response[17],
      })
    )
  );

  return promise;
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step2/actions/requirements.js